import { FormProvider, useForm } from "react-hook-form";
import { Button } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { handleAgregarIncidencia } from "./handlers";
import DateInput from "../../../../components/ReactHookForm/DateInput";
import { TextInput } from "../../../../components";
import { schemaAgregarIncidencia } from "./schemas";

const FormAgregarIncidencia = (props) => {
  const { camara_id, incidencias, setIncidencias } = props;

  const methods = useForm({
    mode: "all",
    resolver: yupResolver(schemaAgregarIncidencia),
    defaultValues: {
      camara_id: camara_id,
    },
  });

  return (
    <FormProvider {...methods}>
      <form
        className="d-flex flex-column gap-0 flex-lg-row gap-2 gap-lg-4"
        onSubmit={methods.handleSubmit((data) =>
          handleAgregarIncidencia(data, setIncidencias, methods.setError)
        )}
      >
        <div style={{ maxWidth: "320px" }}>
          <DateInput
            type="datetime-local"
            label="Fecha de Incidencia"
            name="fecha_incidencia"
            register={methods.register}
            errors={methods.formState.errors?.fecha_incidencia}
          />
        </div>
        <TextInput name="observacion" label="Observación *" />
        <div style={{ maxWidth: "320px", marginTop: '32px' }}>
          <Button
            type="submit"
            className="me-2 me-lg-3"
            disabled={methods.formState.isSubmitting}
            style={{
              height: "38px",
            }}
          >
            Guardar
          </Button>
          <Button
            variant="danger"
            disabled={methods.formState.isSubmitting}
            onClick={() =>
              setIncidencias((prevState) => ({
                ...prevState,
                agregar_incidencia: false,
              }))
            }
            style={{
              height: "38px",
            }}
          >
            Cancelar
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

export default FormAgregarIncidencia;
